import { API_URL } from "../../config/connect";

/**
 * Fetch all countries from the Location API
 * @returns {Promise<Array>} Array of countries
 */
export async function getCountries() {
    const endpoint = `${API_URL}/api/v1/countries`;

    try {
        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const result = await response.json();
        return result.countries || [];
    } catch (error) {
        console.error('Failed to fetch countries:', error);
        throw error;
    }
}

